export const EMAIL = 'thomaschestnut00@gmail.com';

export const CONTACT_TEXT = {
	email: {
		heading: 'Email me at:',
		success: 'Email copied!',
		error: 'Email not copied.',
	},
	social: {
		heading: 'Connect with me on:',
	},
};
